import styled from "styled-components";
import { FiX, FiChevronDown } from "react-icons/fi";
import { CiUser } from 'react-icons/ci'
import { fadeIn, slideInFromRight } from "../../styles/Animations";

export const MenuContainer = styled.div`
  position: fixed;
  z-index: 2;
  top: 0;
  right: ${({ isOpen }) => (isOpen ? "0" : "-100%")};
  width: 100%;
  height: 100vh;
  background: black;
  box-shadow: -2px 0 10px rgba(0, 0, 0, 0.1);
  transition: right 0.3s ease-in-out;
  display: flex;
  flex-direction: column;
  background-color: #F9F9F9;
  animation: ${fadeIn} 0.3s ease-in-out;

  a{
    color: black;
  }
`;

export const MenuHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 3em;
  color: black;
`;

export const IconsContainer = styled.div`
    display: flex;
    align-items: center;
`

export const UserIconContainer = styled.div`
    border: 1px solid black;
    padding: 5px;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    display: grid;
    align-items: center;
    margin-right: 10px;
    justify-content: center;
    
`

export const Logo = styled.div`
  font-size: 20px;
  font-weight: bold;
`;

export const CloseButton = styled(FiX)`
  font-size: 24px;
  cursor: pointer;
`;

export const MenuList = styled.ul`
    padding: 0 3em;
  list-style: none;

  margin-top: 20px;
`;

export const MenuItem = styled.li`
font-size: 16px;
font-weight: ${({ bold }) => (bold ? "bold" : "normal")};
color: #444;
margin: 10px 0;
display: flex;
align-items: center;
justify-content: space-between;
cursor: ${({ hasDropdown }) => (hasDropdown ? "pointer" : "default")};
animation: ${slideInFromRight} 0.3s ease-in-out;

a {
text-decoration: none;
color: #444;

  &:hover {
    color: #EA0B2A;
    transition: color 0.2s;  
  }
}
`;

export const SubMenu = styled.ul`
  list-style: none;
  padding-left: 20px;
  max-height: ${({ isOpen }) => (isOpen ? "200px" : "0")}; 
  overflow: hidden;
  transition: max-height 0.3s ease-in-out;
`;


export const UserIcon = styled(CiUser)`
  font-size: 22px;
  cursor: pointer;
`;

export const DropdownIcon = styled(FiChevronDown)`
  transition: transform 0.3s ease;
  transform: ${({ isOpen }) => (isOpen ? "rotate(180deg)" : "rotate(0)")};
`;
